import {RightCircleOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

import DataMediumBlock from "../../containers/DataMediumBlock";

import styles from "./see-more.module.scss";

const SeeMore = () => {
    return (
        <DataMediumBlock>
            <div className={styles.wrapper}>
                <Link to="/insights">
                    <span className={styles.text}>SEE MORE</span>
                    <RightCircleOutlined className={styles.icon} />
                </Link>
            </div>
        </DataMediumBlock>
    )
}

export default SeeMore;
